import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes, useLocale } from '@gov-nx/core/service';
import { LayoutGap } from '@gov-nx/ui/web';

export const RezaChangeFormSkeleton = () => {
	const { t } = useLocale(LocalizeNameSpaceTypes.Global);

	return (
		<LayoutGap
			gap="l"
			className="mb-8">
			<LayoutGap gap="m">
				<GovSkeleton
					width="80px"
					height="22px"
					color="neutral"
					aria-label={t('loading.wcag.processing')}
					className="mb-0 pb-0"
				/>
				<div className="flex items-center gap-5">
					<GovSkeleton
						width="24px"
						height="24px"
						shape="circle"
						aria-label={t('loading.wcag.processing')}
					/>
					<GovSkeleton
						width="120px"
						height="20px"
						aria-label={t('loading.wcag.processing')}
					/>
				</div>
				<div className="flex items-center gap-5">
					<GovSkeleton
						width="24px"
						height="24px"
						shape="circle"
						aria-label={t('loading.wcag.processing')}
					/>
					<GovSkeleton
						width="95px"
						height="20px"
						aria-label={t('loading.wcag.processing')}
					/>
				</div>
			</LayoutGap>
		</LayoutGap>
	);
};
